import React, { useEffect } from "react";
import { useParams, Navigate, Link } from "react-router-dom";
import { LEGAL, LEGAL_ORDER, LEGAL_VERSION, LEGAL_REVIEWED } from "@/data/legal";
import { useSupportEmail } from "@/lib/config";

export default function LegalPage() {
  const { slug } = useParams();
  const doc = LEGAL[slug];
  const supportEmail = useSupportEmail();
  const sub = (t) => (typeof t === "string" ? t.replaceAll("__CONTACT__", supportEmail) : t);

  useEffect(() => { window.scrollTo(0, 0); }, [slug]);

  if (!doc) return <Navigate to="/" replace />;

  return (
    <div className="container-x py-16 max-w-3xl" data-testid={`legal-page-${slug}`}>
      <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#CC5A3A] mb-2">Legal</div>
      <h1 className="font-heading text-4xl text-[#1E3F33] font-semibold" data-testid="legal-title">{doc.title}</h1>
      <p className="text-sm text-[#8A9A86] mt-2" data-testid="legal-version">Version {LEGAL_VERSION} · Last reviewed {LEGAL_REVIEWED} · Last updated {doc.updated}</p>

      {doc.disclaimer && (
      <div className="mt-5 rounded-xl border border-[#1E3F33]/10 bg-[#F0EFEA]/50 p-4 text-xs text-[#5C6B64]" data-testid="legal-disclaimer">
        {doc.disclaimer}
      </div>
      )}

      {doc.intro && <p className="text-[#5C6B64] mt-6 leading-relaxed">{sub(doc.intro)}</p>}

      <div className="mt-8 space-y-8">
        {doc.sections.map((s, i) => (
          <section key={i} data-testid={`legal-section-${i}`}>
            <h2 className="font-heading text-xl text-[#1E3F33] mb-1">{i + 1}. {s.h}</h2>
            {s.p.map((para, j) => {
              const indent = /^[•\d]/.test(para.trim());
              return (
                <p key={j} className={`text-sm text-[#5C6B64] leading-relaxed mt-2 ${indent ? "pl-4" : ""}`}>{sub(para)}</p>
              );
            })}
          </section>
        ))}
      </div>

      <nav className="mt-12 flex flex-wrap gap-x-5 gap-y-2 text-sm border-t border-[#1E3F33]/10 pt-6" data-testid="legal-nav">
        {LEGAL_ORDER.map((k) => (
          <Link
            key={k}
            to={`/legal/${k}`}
            data-testid={`legal-link-${k}`}
            className={k === slug ? "text-[#CC5A3A] font-medium" : "text-[#5C6B64] hover:text-[#CC5A3A]"}
          >
            {LEGAL[k].title}
          </Link>
        ))}
      </nav>
    </div>
  );
}
